const { createAction } = require("@reduxjs/toolkit");

export const setAddressAndCost = createAction("delivery/setAddressAndCost");
export const clearAddressAndCost = createAction("delivery/clearAddressAndCost");
export const setDeliveryType = createAction("delivery/setDeliveryType");
export const setPickupLocation = createAction("delivery/setPickupLocation");
export const setPickupLock = createAction("delivery/setPickupLock");
